import { apiClient } from './apiClient';
import { Loan, CreateLoanRequest, UpdateLoanRequest, GetLoansRequest } from './types';

const BASE_URL = '/v1/loans';

export const loanService = {
  getAll: async (): Promise<Loan[]> => {
    const response = await apiClient.get<Loan[]>(BASE_URL);
    return response;
  },

  getFiltered: async (request: GetLoansRequest): Promise<Loan[]> => {
    const params = new URLSearchParams();
    
    if (request.dateFrom) params.append('dateFrom', request.dateFrom);
    if (request.dateTo) params.append('dateTo', request.dateTo);
    if (request.accountId) params.append('accountId', request.accountId);
    if (request.loanType !== undefined) params.append('loanType', String(request.loanType));
    if (request.status !== undefined) params.append('status', String(request.status));

    const queryString = params.toString();
    const url = queryString ? `${BASE_URL}?${queryString}` : BASE_URL;
    
    const response = await apiClient.get<Loan[]>(url);
    return response;
  },

  getByAccount: async (accountId: string): Promise<Loan[]> => {
    const response = await apiClient.get<Loan[]>(`${BASE_URL}/account/${accountId}`);
    return response;
  },

  getById: async (id: string): Promise<Loan> => {
    const response = await apiClient.get<Loan>(`${BASE_URL}/${id}`);
    return response;
  },

  create: async (request: CreateLoanRequest): Promise<Loan> => {
    const response = await apiClient.post<CreateLoanRequest, Loan>(BASE_URL, request);
    return response;
  },

  update: async (id: string, request: UpdateLoanRequest): Promise<Loan> => {
    const response = await apiClient.put<UpdateLoanRequest, Loan>(`${BASE_URL}/${id}`, request);
    return response;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE_URL}/${id}`);
  }
};

